import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import useFetch from 'utils/hooks/useFetch';
import { ApiCheckAuth } from 'utils/constants/api';
import { ApiResponseStatusUnauthorized } from 'utils/Constant';
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from 'utils/context/AuthContext';

export default function MainContainer() {
    const { accessToken } = useAuth()

    const location = useLocation()
    const navigate = useNavigate()

    const { fetch: checkAuth } = useFetch(ApiCheckAuth);

    const [isSidebarOpen, setIsSidebarOpen] = useState(
        localStorage.getItem("SidebarState") === "open"
    );

    useEffect(() => {
		if (location.pathname !== "/login") {
            fCheckAuth();
        }
    }, []);

    async function fCheckAuth() {
        if (!accessToken) {
            navigate("/login")
            return
        }

        const response = await checkAuth({
            data: {},
        });

        if (response?.status === ApiResponseStatusUnauthorized) {
            navigate("/login");
        }
    }

    if (location.pathname === "/login") {
        return (
            <div className="overflow-hidden">
                <Outlet />
            </div>
        );
    }

	function fToggleSidebar(state){
		if (state){
			localStorage.setItem("SidebarState", "close")
		}else{
			localStorage.setItem("SidebarState", "open")
		}

		setIsSidebarOpen(!state)
	}

	function fOnMobileToggleSidebar(){
		if (window.innerWidth < 720) {
			fToggleSidebar(isSidebarOpen)
		}
	}

    return (
        <div className="overflow-hidden h-screen w-full flex flex-col bg-black text-sm">
            <div className="sticky top-0 left-0 bottom-0 z-30 shadow-md">
                <Navbar
                    toggleSidebar={() => {
                        fToggleSidebar(isSidebarOpen);
                    }}
                />
            </div>

            <div className="w-full h-[calc(100vh-3.5rem)] overflow-hidden flex bg-white">

                <div className="sticky top-0 z-30">
                    <Sidebar
                        isOpen={isSidebarOpen}
                        onSidebarClick={() => {
                            fOnMobileToggleSidebar();
                        }}
                    />
                </div>

                <div className="w-full overflow-auto bg-white sm:bg-slate-50 text-sm">
                    <Outlet />
                </div>
            </div>
        </div>
    )
}